import React from 'react';
import { useTypedSelector } from 'src/redux/utils';
import ConnectWalletModal from './ConnectWalletModal';
import ChooseHeroModal from '../Components/Staking/ChooseHeroModal';
import { connectWallet } from '@profile/src/redux/remoteActions';
import { navigateToConnectWallet } from 'src/utils/navigate';
import { RouteName } from 'src/routes/config';
var StakeModalName;

(function (StakeModalName) {
  StakeModalName["CONNECT_WALLET"] = "connect_wallet";
  StakeModalName["CHOOSE_HERO"] = "choose_hero";
})(StakeModalName || (StakeModalName = {}));

const StakeContext = /*#__PURE__*/React.createContext({
  chooseHero: () => {},
  connectWallet: () => {},
  openModal: () => {},
  closeModal: () => {},
  resetState: () => {}
});

const StakeProvider = ({
  children
}) => {
  const [modal, setModal] = React.useState();
  const [tokenIdSelectedList, setTokenIdSelectedList] = React.useState([]);
  const [selectAllOption, setSelectAllOption] = React.useState();
  const [quickSelectedNumber, setQuickSelectedNumber] = React.useState(0);
  const tokenIds = tokenIdSelectedList;
  const resetState = React.useCallback(() => {
    setTokenIdSelectedList([]);
  }, []);
  const openModal = React.useCallback(modal => {
    setModal(modal);
  }, []);
  const closeModal = React.useCallback(() => {
    setModal(null);
  }, []);
  const chooseHero = React.useCallback(() => {
    setModal(StakeModalName.CONNECT_WALLET);
  }, []);
  const context = React.useMemo(() => {
    return {
      tokenIds,
      modal: modal || undefined,
      chooseHero,
      selectAllOption: selectAllOption || undefined,
      quickSelectedNumber,
      connectWallet,
      openModal,
      closeModal,
      resetState
    };
  }, [modal, openModal, closeModal, chooseHero, tokenIds, resetState, selectAllOption, quickSelectedNumber]);
  const signedIn = useTypedSelector(state => !!state.userSignIn.accessToken);
  React.useEffect(() => {
    if (signedIn && modal === StakeModalName.CONNECT_WALLET) {
      openModal(StakeModalName.CHOOSE_HERO);
    }
  }, [signedIn, modal]);

  const renderModal = () => {
    switch (modal) {
      case StakeModalName.CONNECT_WALLET:
        return /*#__PURE__*/React.createElement(ConnectWalletModal, {
          onClose: () => {
            closeModal();
          },
          onConnectButtonPressed: () => {
            navigateToConnectWallet({
              redirectTo: RouteName.Staking
            });
          }
        });

      case StakeModalName.CHOOSE_HERO:
        return /*#__PURE__*/React.createElement(ChooseHeroModal, {
          tokenIdsSelected: tokenIds,
          onChooseHeroComplete: (selectedList, selectAllOption, quickSelectedNumber) => {
            setTokenIdSelectedList(selectedList);
            setSelectAllOption(selectAllOption);
            setQuickSelectedNumber(quickSelectedNumber || 0);
            closeModal();
          },
          onClose: () => {
            closeModal();
          }
        });
    }
  };

  return /*#__PURE__*/React.createElement(StakeContext.Provider, {
    value: context
  }, children, renderModal());
};

export const useStakeContext = () => {
  const {
    modal,
    chooseHero,
    tokenIds,
    resetState,
    selectAllOption,
    quickSelectedNumber
  } = React.useContext(StakeContext);
  return {
    modal,
    chooseHero,
    tokenIds,
    resetState,
    selectAllOption,
    quickSelectedNumber
  };
};
export default StakeProvider;